// extracted by mini-css-extract-plugin
export default {"container":"LayoutBtns_container__L02g4","btn":"LayoutBtns_btn__rK4iL","text":"LayoutBtns_text__EsyRD"};